module.exports = __webpack_public_path__ + "img/time_circle.056d9d2c.svg";